/**
 * @file tipDeepLinkPending.js
 * @description 微信内打开打赏深链时未登录，暂存上下文待登录后拉起弹窗
 * @module features/comic/utils/tipDeepLinkPending
 */

const STORAGE_KEY = 'comic_pending_tip_deep_link'

/**
 * @typedef {Object} PendingTipDeepLink
 * @property {string} comicId
 * @property {'detail' | 'reader'} source
 * @property {number} [volNum]
 * @property {string} tipCode
 */

/**
 * 暂存待登录后打开的打赏深链
 * @param {PendingTipDeepLink} payload
 */
export function savePendingTipDeepLink(payload) {
  if (typeof sessionStorage === 'undefined') return
  if (!payload?.comicId || !payload?.tipCode) return
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload))
}

/**
 * 读取并清除待打开的打赏深链
 * @returns {PendingTipDeepLink | null}
 */
export function consumePendingTipDeepLink() {
  if (typeof sessionStorage === 'undefined') return null
  const raw = sessionStorage.getItem(STORAGE_KEY)
  sessionStorage.removeItem(STORAGE_KEY)
  if (!raw) return null
  try {
    const parsed = JSON.parse(raw)
    if (!parsed || typeof parsed !== 'object') return null
    if (!parsed.comicId || !parsed.tipCode) return null
    return parsed
  } catch {
    return null
  }
}

/**
 * 清除待打开的打赏深链
 */
export function clearPendingTipDeepLink() {
  if (typeof sessionStorage === 'undefined') return
  sessionStorage.removeItem(STORAGE_KEY)
}
